import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowRefService } from './services/windowRef.service';
import { ApiService } from './services/api.service';
import { FlagService } from './services/flag.service';

@NgModule({
  declarations: [],
  providers: [WindowRefService, ApiService, FlagService],
  imports: [CommonModule],
})
export class CoreModule {}
